<template>
    <div style="margin:20px 0 0 20px;">
      <el-row :gutter="15">
        <el-form ref="elForm" :model="formData" size="medium" label-width="100px">
          <el-col :span="5">
            <el-form-item label="店铺别名">
              <el-select v-model="formData.vendorAliasIds" filterable multiple collapse-tags clearable placeholder="请选择">
                <el-option v-for="item in vendorList" :key="item.value" :label="item.vendorNameAlias" :value="item.value" value-key="value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="店铺ID" prop="vendorId">
              <el-input type="number" v-model.number="formData.vendorId" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item size="large">
              <el-button type="primary" @click="submitForm">搜索</el-button>
              <el-button @click="resetForm">重置</el-button>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item size="large">
              <el-button type="primary" @click="showAddDialogVisible()">新增配置</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <Row>
        <el-table max-height="600px" ref="selection" :data="listData" border :header-cell-style="tableHeaderColor">
          <el-table-column prop="vendorName" label="店铺名称">
          </el-table-column>
          <el-table-column prop="merchantSelfInvoiceType" label="发票解析方式" >
            <template slot-scope="scope">
            <span v-if="scope.row.merchantSelfInvoiceType === 2">
              <span>Chat GPT</span>
            </span>
            <span v-else-if="scope.row.merchantSelfInvoiceType === 0">
              <span>OCR</span>
            </span>
            <span v-else>
              <span>自有发票</span>
            </span>
          </template>
          </el-table-column>
          <el-table-column  prop="data" label="配置" >
            <template slot-scope="scope">
              <div class="dataLenth">{{scope.row.data}}</div>
              </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
                <el-button @click="showVendorExtDetail(scope.row,false)" type="text" size="small">查看</el-button>
                <el-button @click="showVendorExtDetail(scope.row,true)" type="text" size="small">编辑</el-button>
                <el-button @click="delExtInfo(scope.row.vendorExtInfoId)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </Row>
      <Row class="padding-top-16" type="flex" justify="end">
        <Page :total="totalQuantity" :page-size-opts="pageSizeOpts" :page-size="pageSize" :current="currentPage" @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer show-total></Page>
      </Row>
      <el-dialog title="发票配置信息" :visible.sync="detailDialogVisible">
        <el-form>
          <el-form-item label="店铺名称：" label-width="120px">
            <el-input  :disabled="true" v-model="vendorInfoDetail.vendorName"></el-input>
          </el-form-item>
          <el-form-item label="发票解析方式：" label-width="120px" prop="merchantSelfInvoiceType">
            <el-select :disabled="!editFlag" v-model="invoiceData.merchantSelfInvoiceType">
              <el-option label="Chat GPT" :value="2"></el-option>
              <el-option label="OCR" :value="0"></el-option>
              <el-option label="自有发票" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <div v-if="invoiceData.merchantSelfInvoiceType === 1 || invoiceData.merchantSelfInvoiceType === 0">
            <el-form-item :label="invoiceData.merchantSelfInvoiceType === 0?'OCR配置内容:':'自有发票配置：' " label-width="120px">
              <el-input :disabled="!editFlag" type="textarea" :rows=6 v-model="vendorInfoDetail.data"></el-input>
            </el-form-item>
          </div>

          <div v-if="invoiceData.merchantSelfInvoiceType === 2">
            <div v-if="editFlag">
              <el-form-item label="解析文件：" label-width="120px">
                <el-upload
                  class="upload-demo"
                  :limit="1"
                  action=""
                  :on-change="handleUploadSuccess2"
                  :http-request="uploadSelf2"
                  ref="fileName2"
                  :on-exceed="handleExceed2"
                  :file-list="fileList2"
                  accept=".pdf">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
            </el-form-item>
            </div>
            <el-form-item label="GPT发票内容: " label-width="120px" prop="invoiceText">
              <el-input  type="textarea" :disabled="!editFlag" :rows=6 v-model="invoiceData.invoiceText"></el-input>
            </el-form-item>
            <el-form-item label="发票金额：" label-width="120px">
              <el-input  :disabled="!editFlag" v-model="invoiceData.invoiceAmount"></el-input>
            </el-form-item>
            <el-form-item label="发票号：" label-width="120px" >
              <el-input :disabled="!editFlag" v-model="invoiceData.invoiceNum"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeDialog">关 闭</el-button>
          <el-button type="primary" v-show="editFlag" @click="updateVendorExtInfo">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="新增发票配置信息" :visible.sync="addVendorExtInfoDialogVisible">
        <el-form ref="form" :model="saveInvoiceData">
          <el-form-item label="店铺名称" label-width="120px" :rules="[{ required: true, message: '请选择店铺' }]" prop="vendorId">
              <el-select v-model="saveInvoiceData.vendorId" filterable clearable placeholder="请选择" style="width: 120px;">
                <el-option v-for="item in vendorList" :key="item.value" :label="item.vendorNameAlias" :value="item.value" value-key="value"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="发票配置方式" label-width="120px">
            <el-select v-model="saveInvoiceData.merchantSelfInvoiceType" style="width: 120px;">
              <el-option label="Chat GPT" :value="2"></el-option>
              <el-option label="OCR" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <div v-if="saveInvoiceData.merchantSelfInvoiceType === 1">
            <el-form-item label="OCR发票配置" label-width="120px" :rules="[{ required: true, message: '请输入配置' }]" prop="data">
              <el-input type="textarea" :rows=6 v-model="saveInvoiceData.data"></el-input>
            </el-form-item>
          </div>
          <div v-if="saveInvoiceData.merchantSelfInvoiceType === 2">
            <el-form-item label="解析文件：" label-width="120px">
              <el-upload
                class="upload-demo"
                :limit="1"
                action=""
                :on-change="handleUploadSuccess"
                :http-request="uploadSelf"
                ref="fileName"
                :on-exceed="handleExceed"
                :file-list="fileList"
                accept=".pdf">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="GPT发票内容: " label-width="120px" :rules="[{ required: true, message: '请输入发票内容' }]" prop="invoiceText">
              <el-input v-model="saveInvoiceData.invoiceText" type="textarea" :rows=6 ></el-input>
            </el-form-item>
            <el-form-item label="发票金额：" label-width="120px" :rules="[{ required: true, message: '请输入发票金额' }]" prop="invoiceAmount">
              <el-input v-model="saveInvoiceData.invoiceAmount" style="width: 120px;"></el-input>
            </el-form-item>
            <el-form-item label="发票号：" label-width="120px" :rules="[{ required: true, message: '请输入发票号' }]" prop="invoiceNum">
              <el-input v-model="saveInvoiceData.invoiceNum" style="width: 120px;"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeDialog2">关 闭</el-button>
          <el-button type="primary" @click="addNewVendorExtInfo()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  <script>
  import {
    pageVendorExtInfo,
    vendorExtInfoDetail,
    updateVendorExtInfo,
    getComboVendorList,
    saveVendorExtInfo,
    getPdfFileContent,
    delVendorExtInfo,
  } from "../../../api/trace_cn";
  export default {
    data() {
      return {
        totalQuantity: 0,
        pageSizeOpts: [25, 50, 100, 200],
        pageSize: 25,
        currentPage: 1,
        vendorList: [],
        listData: [],
        formData: {
          vendorIds: [],
          vendorId:null,
        },
        loadingDetail:false,
        detailDialogVisible:false,
        addVendorExtInfoDialogVisible:false,
        editFlag:false,
        vendorInfoDetail:{
          vendorExtInfoId:null,
          vendorName:null,
          invoiceType:null,
          invoiceTypeId:null,
          data:null
        },
        invoiceData:{
          merchantSelfInvoiceType:null,
          invoiceText:'',
          invoiceAmount:'',
          invoiceNum:''
        },
        saveInvoiceData:{
          invoiceText:null,
        },
        gptInvoiceData:{
          merchantSelfInvoiceType:2,
          gptTipContent_1:null,
          gptTipContent_2:',请从第二段内容中找到对应的发票金额和发票号并返回json格式的数据,amount是发票的key,invoiceNo是发票的key'
        },
        files:{},
        files2:{},
        fileList:[],
        fileList2:[],
        firstSplit:null,
        secondSplit:null,
        third:null,
      };
    },
    // computed: {
    //   updateTxt() {
    //     return function (eventType) {
    //       let obj = {
    //         product_all_update: "商品全量",
    //         product_delta_update: "商品增量",
    //         stock_all_update: "库存全量",
    //         stock_delta_update: "库存增量"
    //       };
    //       return obj[eventType];
    //     };
    //   },
    // },
    created() {
      this.getVendorList();
    },
    methods: {
      submitForm() {
        this.$refs["elForm"].validate(valid => {
          if (!valid) return;
          // TODO 提交表单
          this.getList();
        });
      },
      resetForm() {
        this.formData.vendorAliasIds = [];
        this.formData.vendorIds = [];
        this.formData.vendorId = null;
        this.$refs["elForm"].resetFields();
      },
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) return "color:black;";
      },
      pageChange(page) {
        this.currentPage = page;
        this.getList();
      },
      pageSizeChange(pageSize) {
        this.currentPage = 1;
        this.pageSize = pageSize;
        this.getList();
      },
      //查询店铺列表
      getVendorList() {
          getComboVendorList(true)
          .then(res => {
            if (res.data && res.data.data) {
              this.vendorList = res.data.data.map(item => ({
                label: item.vendorName,
                value: item.vendorId,
                vendorNameAlias: item.vendorNameAlias,
              }))
              this.getList();
            }
          });
      },
      closeDialog(){
        this.detailDialogVisible = false;
        this.editFlag=false;
        this. invoiceData = {
          merchantSelfInvoiceType:null,
          invoiceText:'',
          invoiceAmount:'',
          invoiceNum:''
        }
        this.fileList2=[]
      },
      closeDialog2(){
        this.addVendorExtInfoDialogVisible = false;
        this.saveInvoiceData = {invoiceText:null,};
        this.fileList=[]
      },
      getList() {
        this.listData = {};
        this.gatherData = JSON.parse(JSON.stringify(this.formData));
        let params = this.gatherData;
        params.pageSize = this.pageSize;
        params.pageNo = this.currentPage;
        if (params.vendorAliasIds) {
          params.vendorIds = params.vendorAliasIds;
        }
        if(params.vendorId){
          params.vendorIds = [params.vendorId]
        }
        if(params.vendorIds && params.vendorIds.length>0){
          params.pageNo = 1;
        }
        params.infoType=4;
        this.$store.commit("setPageLoading", true);
        pageVendorExtInfo(params)
          .then(res => {
            if (res.status === 200 && res.data.success) {
              var data = res.data.data;
              this.totalQuantity = data.total;
              this.listData = data.list.map(item =>{
                const jsonData = JSON.parse(item.data);
                return {
                  ...item,
                  merchantSelfInvoiceType : jsonData.merchantSelfInvoiceType,
                  vendorName: (this.vendorList.find(v=> v.value == item.vendorId) || {vendorName: ""}).label
                }
              });
              this.$store.commit("setPageLoading", false);
            } else {
              this.$store.commit("setPageLoading", false);
              this.$Notice.error({
                title: res.data.message
              });
            }
          })
          .catch(error => {
            this.$Notice.error({
              title: "请求出错，请刷新重试！"
            });
            this.$store.commit("setPageLoading", false);
          });
      },
      showVendorExtDetail(row,isEdit){
        this.detailDialogVisible = true;
        this.loadingDetail = true;
        this.editFlag=isEdit;
        //this.extInfoData = row;
        vendorExtInfoDetail(row.vendorExtInfoId)
          .then(res => {
            const jsonData = JSON.parse(res.data.data.data);
            //const merchantSelfInvoiceType = parsedData.merchantSelfInvoiceType;
            this.vendorInfoDetail.vendorExtInfoId = res.data.data.vendorExtInfoId;
            this.vendorInfoDetail.data = res.data.data.data;
            this.vendorInfoDetail.vendorName = (this.vendorList.find(v=> v.value == res.data.data.vendorId) || {vendorName: ""}).label;
            this.invoiceData.merchantSelfInvoiceType = jsonData.merchantSelfInvoiceType;
            if(this.invoiceData.merchantSelfInvoiceType === 2){
              this.firstSplit = jsonData.gptTipContent_1.split('其中第一段内容中');
              this.secondSplit = this.firstSplit[1].split('是发票金额 ,');
              this.third = this.secondSplit[1].split('是发票号');
              this.invoiceData.invoiceText = this.firstSplit[0].replace('第一段内容为:','');
              this.invoiceData.invoiceAmount = this.secondSplit[0];
              this.invoiceData.invoiceNum = this.third[0];
            }
          })
          this.loadingDetail = false;
      },
      updateVendorExtInfo(){

        if(this.invoiceData.merchantSelfInvoiceType === 2){
          this.gptInvoiceData.gptTipContent_1 = '第一段内容为: ' + this.invoiceData.invoiceText
          +' ,其中第一段内容中'+this.invoiceData.invoiceAmount+'是发票金额 ,'+this.invoiceData.invoiceNum+' 是发票号,第二段内容为: ';
          this.vendorInfoDetail.data = JSON.stringify(this.gptInvoiceData);
        }

        updateVendorExtInfo(this.vendorInfoDetail).then(res=>{
          if (res.status === 200 && res.data.success) {
            this.$message.success("修改成功");
            this.getList();
          }else{
            this.$message.error(res.data.message);
          }
        });
        this.detailDialogVisible=false;
        this.fileList2=[]
      },
      delExtInfo(extInfoId){
        delVendorExtInfo(extInfoId).then(res=>{
          if (res.status === 200 && res.data.success) {
            this.$message.success("删除成功");
            this.getList();
          }else{
            this.$message.error(res.data.message);
          }
        });
      },
      showAddDialogVisible(){
        this.addVendorExtInfoDialogVisible=true;
      },
      addNewVendorExtInfo(){
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.saveInvoiceData.invoiceText = "第一段内容为: "+ this.saveInvoiceData.invoiceText;
            this.saveInvoiceData.infoType = 4;
            saveVendorExtInfo(this.saveInvoiceData).then(res=>{
              if (res.status === 200 && res.data.success) {
                this.$message.success("新增成功");
                this.getList();
              }else{
                this.$message.error(res.data.message);
              }
              this.detailDialogVisible = false;
              this.saveInvoiceData = {invoiceText:null,};
              this.addVendorExtInfoDialogVisible=false;
            });
          } else {
            this.$message.error('请完善信息');
            return false;
          }
          this.fileList=[]
        });
      },
    uploadSelf() {
      let formData = new FormData();
      formData.append("file", this.files);
      getPdfFileContent(formData).then((res) => {
        if (res.data.success) {
          this.saveInvoiceData.invoiceText = res.data.data;
        } else {
          this.$message.error(res.data.message || res.data.msg);
        }
      });
    },
    uploadSelf2() {
      let formData = new FormData();
      formData.append("file", this.files2);
      getPdfFileContent(formData).then((res) => {
        if (res.data.success) {
          this.invoiceData.invoiceText = res.data.data;
        } else {
          this.$message.error(res.data.message || res.data.msg);
        }
      });
    },
    handleUploadSuccess(file, fileList) {
      this.files = file.raw;
    },
    handleUploadSuccess2(file, fileList) {
      this.files2 = file.raw;
    },
    handleExceed(files, fileList) {
      this.$set(fileList[0], "raw", files[0]);
      this.$set(fileList[0], "name", files[0].name);
      this.$refs["fileName"].clearFiles(); //清除文件
      this.$refs["fileName"].handleStart(files[0]); //选择文件后的赋值方法
      this.$refs["fileName"].submit(); //上传文件
    },
    handleExceed2(files2, fileList) {
      this.$set(fileList2[0], "raw", files2[0]);
      this.$set(fileList2[0], "name", files2[0].name);
      this.$refs["fileName2"].clearFiles(); //清除文件
      this.$refs["fileName2"].handleStart(files[0]); //选择文件后的赋值方法
      this.$refs["fileName2"].submit(); //上传文件
    },
  },
  };
  </script>
  <style lang="less" scoped>
  .dataLenth{
    width: 100%;
    white-space:nowrap;//禁止换行
    }
  </style>
